import css from 'styled-jsx/css';

export default css`.ourResource .socialMedia .flex-wrap .box .name {
  text-transform: uppercase; }

:global(em) {
  color: white; }

h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.42;
  letter-spacing: 0.4px;
  text-align: center;
  color: #414141;
  margin-bottom: 64px;
  position: relative;
  margin-top: 160px; }

h2:after {
  content: '';
  display: block;
  width: 48px;
  height: 8px;
  background-color: #414141;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translateX(-50%); }

.ourResource {
  transition: 0.5s;
  transform: translateY(-100%) scale(0);
  position: absolute; }
  .ourResource h2 {
    text-align: center; }
  .ourResource .socialMedia .flex-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 1080px;
    margin: auto;
    justify-content: space-between;
    margin-bottom: 74px; }
    @media only screen and (max-width: 500px) {
      .ourResource .socialMedia .flex-wrap {
        display: block;
        width: auto;
        margin-bottom: 0; } }
    .ourResource .socialMedia .flex-wrap .box {
      text-align: center;
      transform: translate3d(0px, 100%, 0px) rotateX(-90deg);
      transition: 0.5s;
      transition-delay: 0.5s;
      opacity: 0; }
      @media only screen and (max-width: 500px) {
        .ourResource .socialMedia .flex-wrap .box {
          margin: 64px auto; } }
      .ourResource .socialMedia .flex-wrap .box .number {
        color: #7d7af4;
        position: relative;
        font-size: 30px;
        transform: translate3d(0px, -100%, 0px) rotateX(90deg);
        transition: 0.5s;
        transition-delay: 1s;
        opacity: 0; }
        .ourResource .socialMedia .flex-wrap .box .number em {
          color: #7d7af4;
          font-size: 12px;
          position: absolute;
          top: 0; }
      .ourResource .socialMedia .flex-wrap .box .name {
        font-size: 16px;
        margin-bottom: 2px;
        line-height: 32px; }
      .ourResource .socialMedia .flex-wrap .box .script {
        font-size: 12px;
        color: #6d6d6d; }
  .ourResource .socialMedia .flex-wrap2 {
    width: 850px; }
    @media only screen and (max-width: 500px) {
      .ourResource .socialMedia .flex-wrap2 {
        display: block;
        width: auto; } }
`